<template>
  <el-dialog
    :visible.sync="visible"
    width="1000px"
    title="编辑计量单位"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :append-to-body="true"
  >
    <div class="unit-value-setting">
      <div class="unit-default-setting" :style="{ marginBottom: '20px' }">
        <span>默认单位：</span>
        <el-select v-model="defaultUnit" placeholder="请选择默认单位">
          <el-option v-for="unit in defaultOptions" :key="unit" :label="unit" :value="unit" />
        </el-select>
      </div>
      <div class="unit-setting-h2">计量单位</div>
      <div class="unit-setting-header">
        <div class="tool-content-btn" @click="addHandle">
          <img :src="addImg" alt="" />
          <span>增加</span>
        </div>
        <div class="tool-content-btn" @click="clearHandle">
          <i class="el-icon-delete"></i>
          <span>删除全部</span>
        </div>
        <div class="tool-content-btn upload-btn">
          <img :src="importImg" alt="" />
          <span>导入excel</span>
          <input type="file" accept=".xlsx" class="upload-input" @change="importHandle" />
        </div>
        <div class="tool-content-btn" @click="exportHandle">
          <img :src="exportImg" alt="" />
          <span>导出excel</span>
        </div>
      </div>
      <div class="unit-setting-content" ref="settingContentRef">
        <div id="spreadsheet"></div>
      </div>
    </div>

    <span slot="footer">
      <el-button @click="visible = false">
        <span>取消</span>
      </el-button>
      <el-button type="primary" @click="confirmHandle">
        <span>确认</span>
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import exportImg from '@/assets/img/导出gray.png';
import importImg from '@/assets/img/导入gray.png';
import addImg from '@/assets/img/增加@2x.png';

import Xlsx from 'xlsx';
import { exportExcel } from '@/lib/utils';
import jspreadsheet from 'jspreadsheet-ce';
import 'jspreadsheet-ce/dist/jspreadsheet.css';
import 'jsuites/dist/jsuites.css';

export default {
  data() {
    return {
      exportImg,
      importImg,
      addImg,
      importing: false,
      jspreadsheetEl: null,
      defaultOptions: [],
      defaultUnit: undefined,
      curNumClassifyUnit: []
    };
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    numClassifyUnit: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    visible: {
      get() {
        return this.show;
      },
      set(val) {
        this.$emit('update:show', val);
      }
    }
  },
  beforeDestroy() {
    if (this.jspreadsheetEl) {
      this.jspreadsheetEl.destroy();
    }
  },
  mounted() {
    this.curNumClassifyUnit = [...this.numClassifyUnit];

    this.refreshDefaultInfo();

    this.$nextTick(() => {
      this.initJspreadsheet(this.curNumClassifyUnit);
    });
  },
  methods: {
    refreshDefaultInfo() {
      this.defaultOptions = this.curNumClassifyUnit.map(unitItem => unitItem.unit);

      if (this.defaultOptions.includes(this.defaultUnit)) {
        return;
      }

      const defaultItem = this.curNumClassifyUnit.find(unitItem => unitItem.default);
      if (defaultItem) {
        this.defaultUnit = defaultItem.unit;
      } else if (this.defaultOptions.length > 0) {
        this.defaultUnit = this.defaultOptions[0];
      } else {
        this.defaultUnit = undefined;
      }
    },
    async confirmHandle() {
      await this.$nextTick();

      this.upgradeNumClassifyUnit();

      const arr = this.curNumClassifyUnit.map(item => {
        let transform = item.transform;
        if (!isNaN(transform) && transform !== null && transform !== '') {
          transform = Number(transform);
        }
        return { ...item, transform, default: item.unit === this.defaultUnit };
      });
      this.$emit('change', arr);
      this.visible = false;
    },
    initJspreadsheet(val = []) {
      let data = [];
      if (val.length) {
        data = val.map(o => [o.unit, o.reg, o.transform]);
      }
      const addEmptyCount = 5 - data.length;
      for (let i = 0; i < addEmptyCount; i++) {
        data.push([]);
      }
      if (this.jspreadsheetEl) {
        this.jspreadsheetEl.setData(data);
      } else {
        this.jspreadsheetEl = jspreadsheet(document.getElementById('spreadsheet'), {
          data,
          columns: [
            { type: 'text', title: '单位名称', width: 120 },
            { type: 'text', title: '在文书多种表述（多个表述用 | 分割开）', width: 626 },
            { type: 'text', title: '转换比例', width: 120 },
            { type: 'text', title: '操作', width: 40, align: 'center' }
          ],
          onchange: () => {
            this.upgradeNumClassifyUnit();
          },
          defaultColAlign: 'left',
          allowExport: false,
          columnSorting: false,
          columnResize: false,
          rowDrag: false,
          allowDeletingAllRows: true,
          allowInsertColumn: false,
          allowManualInsertColumn: false,
          allowDeleteColumn: false,
          allowRenameColumn: false,
          contextMenu: (obj, x, y) => {
            if (y === null) {
              return;
            }
            return [
              { title: '在此前插入行', onclick: () => obj.insertRow([], parseInt(y), 1) },
              { title: '在此后插入行', onclick: () => obj.insertRow([], parseInt(y)) },
              {
                title: '删除选中行',
                onclick: () => {
                  obj.deleteRow(parseInt(y));
                  this.upgradeNumClassifyUnit();
                }
              }
            ];
          },
          onselection: (obj, startX, startY, endX, endY) => {
            if (startX !== 3 || startX !== endX || startY !== endY) {
              return;
            }
            this.jspreadsheetEl.deleteRow(parseInt(startY));
            this.upgradeNumClassifyUnit();
          }
        });
      }
    },
    upgradeNumClassifyUnit() {
      if (!this.jspreadsheetEl) {
        return;
      }
      const numClassifyUnit = this.jspreadsheetEl.getData().map(rowInfo => {
        return { unit: (rowInfo[0] || '').trim(), reg: rowInfo[1], transform: rowInfo[2] };
      });
      const arr = numClassifyUnit.filter(item => item.unit);
      const m = new Map();
      arr.forEach(item => {
        if (!item.unit) {
          return;
        }
        if (m.has(item.unit)) {
          const preItem = m.get(item.unit);
          let regArr = (preItem.reg || '').split(/\||丨/).map(text => text.replace(/[ \n\r\t]/g, ''));
          regArr = [...regArr, ...(item.reg || '').split(/\||丨/).map(text => text.replace(/[ \n\r\t]/g, ''))].filter(
            text => !!text
          );
          m.set(item.unit, { ...item, reg: [...new Set(regArr)].join('|') });
        } else {
          const regArr = (item.reg || '')
            .split(/\||丨/)
            .map(text => text.replace(/[ \n\r\t]/g, ''))
            .filter(text => !!text);
          m.set(item.unit, { ...item, reg: [...new Set(regArr)].join('|') });
        }
      });
      this.curNumClassifyUnit = [...m.keys()].map(key => {
        return m.get(key);
      });
      this.refreshDefaultInfo();
    },
    async importHandle(event) {
      if (this.importing) {
        return;
      }
      const file = event.target.files[0];
      if (!file) {
        return;
      }
      event.target.value = '';
      try {
        this.importing = true;
        const result = await new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onload = resolve;
          reader.onerror = reject;
          reader.readAsArrayBuffer(file);
        });
        const workbook = Xlsx.read(result.target.result, { type: 'buffer' });
        let sheetName = 'sheet1';
        if (workbook.Sheets) {
          if (!workbook.Sheets[sheetName]) {
            sheetName = 'Sheet1';
            if (!workbook.Sheets[sheetName]) {
              throw new Error('excel解析失败，请先导出excel并修改后再导入');
            }
          }
        } else {
          throw new Error('excel解析失败，请先导出excel并修改后再导入');
        }
        const arr = Xlsx.utils
          .sheet_to_json(workbook.Sheets[sheetName])
          .filter(item => {
            return !!item['单位名称'] || item['单位名称'] === 0;
          })
          .map(item => {
            return {
              unit: String(item['单位名称'] || '').replace(/[ \n\r\t]/g, ''),
              reg: String(item['在文书多种表述（多个表述用 | 分割开）'] || '').replace(/[ \n\r\t]/g, ''),
              transform: item['转换比例'] || '',
              default: false
            };
          })
          .filter(item => {
            return !!item.unit;
          });
        if (arr.length === 0) {
          throw new Error('导入失败，excel为空。');
        }
        this.jspreadsheetEl.setData(arr.map(o => [o.unit, o.reg, o.transform]));
        this.curNumClassifyUnit = arr;
        this.refreshDefaultInfo();
      } catch (err) {
        this.$error(err);
      } finally {
        this.importing = false;
      }
    },
    exportHandle() {
      const sheetHeader = ['单位名称', '在文书多种表述（多个表述用 | 分割开）', '转换比例'];
      const excelData = [sheetHeader];
      this.jspreadsheetEl.getData().forEach(rowInfo => {
        excelData.push([rowInfo[0], rowInfo[1], rowInfo[2]]);
      });
      exportExcel(Xlsx.utils.aoa_to_sheet(excelData), `计量单位.xlsx`);
      this.$message.success('excel导出成功');
    },
    clearHandle() {
      this.jspreadsheetEl.setData([[]]);
      this.defaultOptions = [];
      this.defaultUnit = '';
    },
    addHandle() {
      if (this.jspreadsheetEl.getData().length > 0) {
        this.jspreadsheetEl.insertRow();
      } else {
        this.clearHandle();
      }
      this.$nextTick(() => {
        this.$refs.settingContentRef.scrollTop = this.$refs.settingContentRef.childNodes[0].clientHeight;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.unit-value-setting {
  .unit-setting-h2 {
    font-size: 14px;
    color: #2c3443;
    line-height: 20px;
    font-weight: bold;
    margin-bottom: 6px;
  }
  .unit-setting-content {
    position: relative;
    max-height: 800px;
    overflow: auto;
    margin-top: 10px;

    &::-webkit-scrollbar {
      display: none;
    }
    ::v-deep #spreadsheet {
      width: 100%;

      .jexcel > thead > tr > td {
        background-color: #f8fafd;
        line-height: 32px;
      }

      .jexcel > tbody > tr > td:first-child {
        background-color: #f8fafd;
      }

      .jexcel > tbody > tr > td:last-child {
        cursor: pointer;

        &::before {
          font-size: 12px;
          content: 'X'; // 删除
          color: #409eff;
        }
      }
    }
  }
  .unit-setting-header {
    .tool-content-btn {
      display: inline-block;
      padding: 5px;
      padding-left: 0;
      font-size: 12px;
      cursor: pointer;
      margin-right: 10px;

      &.upload-btn {
        position: relative;
        overflow: hidden;
        vertical-align: bottom;

        .upload-input {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          opacity: 0;
          z-index: 1;
          cursor: pointer;
        }
      }

      &.tip-desc {
        font-size: 12px;
        color: rgba(44, 52, 67, 0.5);
        cursor: auto;
        margin-left: 2px;
      }

      & > .el-icon-delete {
        position: relative;
        top: 1px;
        color: #999;
        font-size: 14px;
        margin-right: 4px;
      }

      & > img {
        position: relative;
        top: 2px;
        width: 14px;
        margin-right: 4px;
      }
    }
  }
}
</style>
